import PropertiesMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/PropertiesMultiSelect";
import OrganizationsMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect";
import BaseFilters from "@/components/v2/molecules/admin/shared/BaseFilters";
import CategorySelect from "@/components/v2/molecules/admin/shared/CategorySelect";
import TagSelect from "@/components/v2/molecules/admin/shared/TagSelect";
import { useMemo } from "react";
import { filterActiveContracts } from "@/utils/contractUtils";

interface ExpenseFiltersProps {
  categories: { id: string; name: string }[];
  tags: { id: string; name: string; color: string }[];
  searchTerm: string;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  hasActiveFilters: boolean;
  properties: { id: string; shortName?: string; title?: string }[];
  organizations: any[];
  contracts: any[];
  selectedCategory: string;
  selectedTag: string;
  selectedOrganizations: string[];
  selectedProperties: string[];
  clearFilters: () => void;
  setSearchTerm: (value: string) => void;
  setDateFrom: (value: Date | undefined) => void;
  setDateTo: (value: Date | undefined) => void;
  setSelectedCategory: (value: string) => void;
  setSelectedTag: (value: string) => void;
  setSelectedOrganizations: (value: string[]) => void;
  setSelectedProperties: (value: string[]) => void;
}

const ExpenseFilters = ({
  categories,
  tags,
  searchTerm,
  dateFrom,
  dateTo,
  properties,
  organizations,
  contracts,
  selectedCategory,
  selectedTag,
  selectedOrganizations,
  selectedProperties,
  hasActiveFilters,
  clearFilters,
  setSearchTerm,
  setDateFrom,
  setDateTo,
  setSelectedCategory,
  setSelectedTag,
  setSelectedOrganizations,
  setSelectedProperties,
}: ExpenseFiltersProps) => {
  // Filter properties based on selected organizations
  const filteredProperties = useMemo(() => {
    if (selectedOrganizations.length === 0) {
      const activePropertyIds = new Set(
        filterActiveContracts(contracts).map(c => c.property_id)
      );
      return properties.filter(p => activePropertyIds.has(p.id));
    }

    const propertyIdsInOrganizations = filterActiveContracts(contracts)
      .filter((contract: any) =>
        selectedOrganizations.includes(contract.organization_id)
      )
      .map((contract: any) => contract.property_id);

    return properties.filter((property: any) =>
      propertyIdsInOrganizations.includes(property.id)
    );
  }, [properties, selectedOrganizations, contracts]);

  const handleDateRangeChange = (from: Date | undefined, to: Date | undefined) => {
    setDateFrom(from);
    setDateTo(to);
  };

  return (
    <BaseFilters
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder="Buscar por descripción..."
      dateFrom={dateFrom}
      dateTo={dateTo}
      onDateRangeChange={handleDateRangeChange}
      hasActiveFilters={hasActiveFilters}
      onClearFilters={clearFilters}
    >
      <OrganizationsMultiSelect
        organizations={organizations}
        selectedOrganizations={selectedOrganizations}
        onSelectionChange={setSelectedOrganizations}
      />

      <PropertiesMultiSelect
        properties={filteredProperties as any}
        selectedProperties={selectedProperties}
        onSelectionChange={setSelectedProperties}
      />

      <CategorySelect
        categories={categories}
        value={selectedCategory}
        onChange={setSelectedCategory}
      />

      <TagSelect
        tags={tags}
        value={selectedTag}
        onChange={setSelectedTag}
      />
    </BaseFilters>
  );
};

export default ExpenseFilters;


